// @ts-nocheck
/**
 * travel days constants
 */
export const TRAVEL_DAYS = {
  TRAVEL_DAY_TYPE: {
    PROCEEDING_POSITION: "proceedingPosition",
    FOLLOWING_POSITION: "followingPosition",
    BOTH: "both",
  },
  NUMBER_OF_DAYS: {
    ONE: "1",
    TWO: "2",
    THREE: "3",
  },
  RATE_TYPE: {
    FULL_DAY: "fullDay",
    HALF_DAY: "halfDay",
    CUSTOM_AMOUNT: "custom",
  },
  CUSTOM_AMOUNT_TYPE: {
    PER_DAY: "perDay",
    LUMP_SUM: "lumpSum",
  },
  CHARGES_APPLIED_TO: {
    CONTRACTOR_ONLY: "contractor",
    CUSTOMER_ONLY: "customer",
    BOTH: "both",
  },
};

export const TRAVEL_DAYS_VALUE_LABELS = {
  proceedingPosition: "Proceeding Position",
  followingPosition: "Following Position",
  both: "Both (Proceeding and Following Position)",
  fullDay: "Full Day",
  halfDay: "Half Day",
  custom: "Custom Amount",
  perDay: "Per Day",
  lumpSum: "Lump Sum",
  contractor: "Contractor Only",
  customer: "Customer Only",
};